import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface UpdatePhotoPayload {
  rotate: number;
  rotateIncrement: number;
}

interface RotatePhoto {
  format: string;
  rotateIncrement: number;
  rotate?: number;
}

export default (makeCall: MakeCall) => (
  listingId: number,
  photoId: number,
  { rotate, rotateIncrement, format }: RotatePhoto,
) =>
  makeCall<UpdatePhotoPayload>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/photo/${photoId}`,
    {
      query: { format },
      data: {
        rotateIncrement,
        ...(rotate ? { rotate } : {}),
      },
    },
  );
